import type Farm from "@/models/farm";
import FarmRepository from "@/repositories/farmRepository";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useAuthStore } from "./auth";

export const useFarmStore = defineStore("farm", () => {
  const farm = ref<Farm | null>(null);
  const isLoadingFarm = ref(false);

  // Shared in-flight request so concurrent getFarm calls (e.g. auto-login + a page
  // mount) reuse the same GET instead of firing duplicates.
  let farmRequest: Promise<void> | null = null;

  function getFarm(): Promise<void> {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) return Promise.resolve();
    if (farmRequest) return farmRequest;

    isLoadingFarm.value = true;
    farmRequest = FarmRepository.getSelected()
      .then((selected) => {
        farm.value = selected;
      })
      .finally(() => {
        isLoadingFarm.value = false;
        farmRequest = null;
      });
    return farmRequest;
  }

  return { farm, isLoadingFarm, getFarm };
});
